import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Leisure = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.515 6.485a24.27 24.27 0 0 0-3.791-3.093C28.536.299 23.348.1 20.854.1h-.1c-1.995.1-5.487.598-9.179 2.494-1.397.698-3.292 1.995-5.188 3.89C.601 12.372.102 19.955.002 20.952c0 1.497-.2 7.184 3.392 12.77 1.197 1.896 2.395 3.094 3.093 3.792 6.884 6.784 16.063 6.385 16.86 6.385 4.39-.2 7.683-1.796 9.18-2.594a22.16 22.16 0 0 0 5.088-3.791c.898-.898 2.294-2.395 3.492-4.59A22.397 22.397 0 0 0 44 23.246c-.1-.599.3-9.877-6.485-16.761Zm-2.295.798-8.28 8.38c-3.393-3.79-5.089-8.68-5.089-13.468 4.79 0 9.578 1.696 13.37 5.088ZM19.756 2.295a21.955 21.955 0 0 0 5.687 14.765l-3.492 3.492L8.681 7.283c3.194-2.893 7.085-4.49 11.075-4.988ZM7.186 8.779l13.269 13.27-3.492 3.492a21.955 21.955 0 0 0-14.766-5.687c.499-3.99 2.095-7.982 4.988-11.075ZM2.096 21.95c4.789 0 9.578 1.696 13.469 5.088l-8.38 8.38c-3.393-3.89-5.089-8.68-5.089-13.468Zm6.585 14.866 8.38-8.381c3.393 3.791 5.089 8.68 5.089 13.469-4.889 0-9.678-1.696-13.47-5.088Zm15.464 4.988a21.955 21.955 0 0 0-5.687-14.766l3.492-3.492 13.27 13.27c-3.193 2.893-7.084 4.49-11.075 4.988Zm12.57-6.485-13.268-13.27 3.492-3.491a21.955 21.955 0 0 0 14.765 5.687c-.498 3.99-2.095 7.881-4.988 11.074Zm-8.38-18.258 8.38-8.38c3.393 3.79 5.09 8.58 5.09 13.468-4.79.1-9.579-1.596-13.47-5.088Z"
  }));
});
Leisure.displayName = 'Leisure';
Leisure.defaultProps = {
  'aria-label': 'Leisure'
};
export default Leisure;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Leisure.js
// module id = 3656
// module chunks = 11